(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-details"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const details = document.querySelector('[data-testid="product-information-details"]');
    const quantityPickers = details?.querySelectorAll('.quantity-pickers button.quantity-picker');

    if (!details || !quantityPickers?.length) return;

    const findVariantPicker = () => details.querySelector('variant-picker');

    const getSizeInputs = () => {
      const picker = findVariantPicker();
      if (!picker) return {};

      const sizeContainer = picker.querySelector('.variant-option--hidden');
      if (!sizeContainer) return {};

      const sizeSelect = sizeContainer.querySelector('select');
      const sizeRadios = sizeContainer.querySelectorAll('input[type="radio"]');

      return { picker, sizeSelect, sizeRadios };
    };

    const setActiveButton = (value) => {
      if (!value) return;
      quantityPickers.forEach((btn) => {
        btn.classList.toggle('active', btn.dataset.variantName === value);
      });
    };

    const syncFromVariantPicker = () => {
      const { sizeSelect, sizeRadios } = getSizeInputs();
      if (sizeSelect) {
        setActiveButton(sizeSelect.value);
        return;
      }

      const checkedRadio = Array.from(sizeRadios || []).find((radio) => radio.checked);
      if (checkedRadio) {
        setActiveButton(checkedRadio.value);
      }
    };

    const updateVariant = (variantName) => {
      const { picker, sizeSelect, sizeRadios } = getSizeInputs();
      if (!picker) return;

      if (sizeSelect) {
        sizeSelect.value = variantName;
        sizeSelect.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }

      const targetRadio = Array.from(sizeRadios || []).find((radio) => radio.value === variantName);
      if (!targetRadio) return;

      targetRadio.checked = true;
      targetRadio.dispatchEvent(new Event('change', { bubbles: true }));
    };

    details.addEventListener('click', (event) => {
      const button = event.target.closest('button.quantity-picker');
      if (!button || !details.contains(button)) return;

      const variantName = button.dataset.variantName;
      if (!variantName) return;

      updateVariant(variantName);
      setActiveButton(variantName);
    });

    details.addEventListener('change', (event) => {
      if (!event.target.closest('variant-picker')) return;
      syncFromVariantPicker();
    });

    syncFromVariantPicker();
  });
  } catch(e) { console.error(e); }
})();

})();
